'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope){
    $(scope).tabs('.pane', {
        tabs: 'li'
    });
}
